module.exports = __webpack_public_path__ + "static/img/trackIcon.f966cc5b.png";